var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.modalId,
        size: "md",
        "no-close-on-backdrop": "",
        "no-close-on-esc": "",
        "no-fade": "",
        "no-stacking": "",
        centered: "",
        "hide-footer": ""
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function() {
            return [
              _c("div", { staticClass: "my-auto" }, [
                _c(
                  "h2",
                  {
                    staticClass: "font-weight-normal",
                    attrs: {
                      "data-test-hook": "mobile-subscription-modal-header"
                    }
                  },
                  [
                    _c("div", [
                      _c("i", {
                        staticClass: "far fa-warning colorOrange mr-1",
                        attrs: {
                          "data-test-hook":
                            "mobile-subscription-modal-header-icon"
                        }
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("xYourAccountNeedsAttentionHeader")) +
                          " "
                      )
                    ])
                  ]
                )
              ]),
              _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn-icon-button--gray",
                      attrs: {
                        variant: "icon-button",
                        "data-test-hook": "x-button-feedback-modal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.hide(_vm.modalId)
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-times" })]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", [
        _c("p", [_vm._v(_vm._s(_vm.$t("xYouHaveProductsNotIncludedInAPlan")))]),
        _c("p", [_vm._v(_vm._s(_vm.storeManageText))]),
        _c("div", { staticClass: "row mb-3" }, [
          _c("a", { attrs: { href: _vm.storeLink, target: "_blank" } }, [
            _c(
              "span",
              {
                staticClass: "ml-3",
                attrs: { "data-test-hook": "manage-plan-text" }
              },
              [_vm._v(" " + _vm._s(_vm.storeLink) + " ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }